import {translation} from "@2d-front-monorepo/core";
import React, {JSX} from "react";
import {permitStatusLabel, permitStatusName} from "../helpers/enumNaming";
import {PermitResult} from "../index";

export default function PermitStatusComponent({permit}: { permit: PermitResult }): JSX.Element {
	const pillClass = `pill pill__permit-status--${permitStatusName(permit.status.type)}`;
	return (<div className={pillClass}>{translation(permitStatusLabel(permit.status.type))}</div>);
}
